import { Moment } from 'moment-timezone';

export class PriorAuthSearch {
  priorAuthorizationSearchTypeId: number;
  priorAuthorizationRequestTypeId?: number;
  priorAuthorizationId?: number;
  priorAuthSystemId: string;
  objectStatusId?: string;
  wCBCaseNumber?: string;
  parSubmissionDateFrom?: Moment;
  parSubmissionDateTo?: Moment;
  parStatusDateFrom?: Moment;
  parStatusDateTo?: Moment;
  claimantLastName?: string;
  providerName?: string;
  claimAdminClaimNumber?: string;
  InsurerNumber?: string;
}
